import { Box, Button, Dialog, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import {
	companyRegistredAddressDetailColumns,
	factoryAddressDetailColumns,
} from "data/supplierPageData";
import { useState } from "react";
import { stateList } from "data/stateMasterList";
import {
	SupplierModalActions,
	SupplierModalHeader,
	modalCancelBtnSx,
	modalContentSx,
	modalFormStack,
	supplierModalPaperProps,
	supplierUi,
} from "../../../shared/supplierUi";

const EditAddressDetails = ({ addressData, setAddressData, modalOpen, setModalOpen, submitFunction, companyData }) => {
	const [updatedDetails, setUpdatedDetails] = useState(addressData);
	const [officePincodeError, setOfficePinCodeError] = useState("");

	const handlePinCodeChange = (event, col) => {
		const value = event.target.value;
		let obj = {};
		obj[col] = value;
		setUpdatedDetails({ ...updatedDetails, ...obj });

		const isValidPinCode = /^\d{6}$/.test(value);
		if (!isValidPinCode) {
			setOfficePinCodeError("pincode must be 6 digits");
		} else {
			setOfficePinCodeError("");
		}
	};

	const handleCloseModal = () => {
		setUpdatedDetails(addressData);
		setModalOpen(false);
	};
	const handleFormSubmit = (e) => {
		e.preventDefault();
		let obj = {};
		Object.keys(factoryAddressDetailColumns).forEach((col) => (obj[col] = updatedDetails[col]));
		if (typeof submitFunction === "function") submitFunction(obj, setModalOpen);
	};

	const handleCompanyAdressCopyClick = () => {
		setUpdatedDetails({
			...updatedDetails,
			[factoryAddressDetailColumns.factory_address.key]:
				companyData?.[companyRegistredAddressDetailColumns.registred_office_address.key],
			[factoryAddressDetailColumns.factory_city.key]:
				companyData?.[companyRegistredAddressDetailColumns.registred_office_city.key],
			[factoryAddressDetailColumns.factory_pin_code.key]:
				companyData?.[companyRegistredAddressDetailColumns.registred_office_pin_code.key],
			[factoryAddressDetailColumns.factory_state.key]:
				companyData?.[companyRegistredAddressDetailColumns.registred_office_state.key],
		});
	};

	return (
		<Dialog
			fullWidth
			maxWidth="md"
			open={modalOpen}
			onClose={handleCloseModal}
			component="form"
			onSubmit={handleFormSubmit}
			PaperProps={supplierModalPaperProps}>
			<SupplierModalHeader title="Edit factory address" subtitle="Factory location and registered address details" />
			<Box sx={{ ...modalContentSx, pt: 2.5 }}>
				<Stack direction="row" width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={2} columnGap={1}>
					<Stack
						direction={{ xs: "column", sm: "row" }}
						width="100%"
						justifyContent="space-between"
						alignItems={{ xs: "stretch", sm: "center" }}
						spacing={1}>
						<Typography sx={{ fontWeight: 600, fontSize: 14, color: supplierUi.textPrimary }}>
							Factory Address
						</Typography>
						<Button variant="outlined" onClick={handleCompanyAdressCopyClick} sx={modalCancelBtnSx}>
							Copy company address
						</Button>
					</Stack>
					<Stack sx={{ width: "100%" }} spacing={0}>
						<InputLabel>Factory Address</InputLabel>
						<TextField
							size="small"
							type="text"
							multiline
							rows={2}
							value={updatedDetails.factory_address}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, factory_address: e.target.value })}
							placeholder="Enter Address"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Factory City</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails.factory_city}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, factory_city: e.target.value })}
							placeholder="Enter city name"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Factory State</InputLabel>
						<Select
							value={updatedDetails.factory_state}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, factory_state: e.target.value })}
							MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
							size="small"
							fullWidth
							required>
							<MenuItem value={"select"}>Select State</MenuItem>
							{stateList &&
								stateList.map((row) => (
									<MenuItem key={row.state} value={row.state}>
										{row.state}
									</MenuItem>
								))}
						</Select>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Pincode</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails.factory_pin_code}
							onChange={(e) => handlePinCodeChange(e, "factory_pin_code")}
							placeholder="Enter 6 digit pincode"
							required
						/>
						{officePincodeError ? (
							<Typography variant="caption" color="error" mt={0.5}>
								{officePincodeError}
							</Typography>
						) : null}
					</Stack>
				</Stack>
			</Box>
			<SupplierModalActions onCancel={handleCloseModal} />
		</Dialog>
	);
};

export default EditAddressDetails;
